import { Component } from '@angular/core';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { CommonService } from '../../services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  public admin_name: any = localStorage.getItem('admin_name');



  constructor(
    public authenticationSvc: AuthenticationService,
    protected commonSvc: CommonService,
    public router: Router,
  ){}



}
